import Vue from 'vue'
import App from './App'
import router from './router/router'

import store from './store'

import i18n from './lang'
import './plugins'
import './directives'
Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
